import script from "./theme-switcher-icon.vue?vue&type=script&setup=true&lang=js"
export * from "./theme-switcher-icon.vue?vue&type=script&setup=true&lang=js"

import "./theme-switcher-icon.vue?vue&type=style&index=0&id=264f5c98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-264f5c98"]])

export default __exports__